// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-btn[data-v-47d8f1d3]{max-width:50%!important;font-size:14px!important}.bx--btn-set[data-v-47d8f1d3]{height:100%}.wizard-checkbox[data-v-47d8f1d3]{margin-left:16px}.error-notification[data-v-47d8f1d3]{position:absolute!important;right:0;top:0;height:unset}", ""]);
// Exports
module.exports = exports;
